import { useState, useEffect } from 'react';

export default function StickyMobileBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white border-t border-slate-200 shadow-2xl">
      <div className="flex items-stretch h-16 safe-area-bottom">
        {/* Call */}
        <a
          href="tel:05055600419"
          className="flex-1 flex flex-col items-center justify-center gap-1 text-slate-700 hover:bg-slate-50 transition-colors border-r border-slate-200 cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-phone-fill text-xl text-slate-700" />
          </div>
          <span className="text-xs font-semibold">Ara</span>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/905055600419?text=Merhaba%2C%20temizlik%20hizmeti%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
          target="_blank"
          rel="nofollow noreferrer"
          className="flex-1 flex flex-col items-center justify-center gap-1 bg-emerald-500 text-white hover:bg-emerald-600 transition-colors cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-whatsapp-line text-2xl" />
          </div>
          <span className="text-xs font-bold">WhatsApp</span>
        </a>

        {/* Appointment */}
        <a
          href="#iletisim"
          className="flex-1 flex flex-col items-center justify-center gap-1 bg-sky-600 text-white hover:bg-sky-700 transition-colors border-l border-slate-200 cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-calendar-check-line text-xl" />
          </div>
          <span className="text-xs font-bold">Randevu</span>
        </a>
      </div>
    </div>
  );
}
